import { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Modal, MODAL_SIZES, MODAL_VARIANTS, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { SETTINGS_SAVE_CHANGES_MODAL } from '../../../constants';
import { closeModal } from '../../../ducks';

export const SAVE_EDITS_BUTTON_TEST_ID = 'save-settings-changes-button';
export const CLEAR_EDITS_BUTTON_TEST_ID = 'clear-settings-changes-button';

export interface SettingsSavedChangesModalProps {
  /** Callback to discard changes */
  onDiscard: () => void;
  /** callback to save changes */
  onSave: () => void;
  /** Whether the modal is open */
  isOpen: boolean;
  /** Custom modal body */
  modalBody: ReactNode;
}

export const SettingsSaveChangesModal: React.FC<
  React.PropsWithChildren<SettingsSavedChangesModalProps>
> = ({ onSave, isOpen, modalBody }) => {
  const dispatch = useDispatch();

  const handleCloseModal = () => dispatch(closeModal(SETTINGS_SAVE_CHANGES_MODAL));

  const handleUpdate = () => {
    onSave();
    handleCloseModal();
  };

  return (
    <Modal
      id={SETTINGS_SAVE_CHANGES_MODAL}
      isModalOpen={isOpen}
      onClose={handleCloseModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Save changes?</ModalHeader>
      <ModalBody>{modalBody}</ModalBody>
      <ModalFooter>
        <Button
          data-test={SAVE_EDITS_BUTTON_TEST_ID}
          autoFocus
          onClick={handleUpdate}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          Save settings
        </Button>
      </ModalFooter>
    </Modal>
  );
};
